module.exports = __webpack_public_path__ + "static/assets/070cb59572afba5416e21e732d098557.png";